import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

// Importing the main components
import SplashScreen from "./components/SplashScreen";
import HomeScreen from "./components/HomeScreen";
import SignupScreen from "./components/SignupScreen";
import ForgotPasswordScreen from "./components/ForgotPasswordScreen";

// Importing the dashboard components
import BlogDashboardScreen from "./components/Dashboard/BlogDashboardScreen";

// Component to handle login redirection
const LoginRedirect = () => {
  useEffect(() => {
   // window.location.href = "http://localhost:3001/sign-in";
    window.location.href = "https://nasels-blog-dashboard.vercel.app/sign-in";
  }, []);

  return null; // Since it's a redirect, we don't render anything
};

function App() {
  const [showSplash, setShowSplash] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowSplash(false);
    }, 3000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <Router>
      <div className="App">
        <Routes>
          <Route
            path="/"
            element={showSplash ? <SplashScreen /> : <HomeScreen />}
          />
          <Route path="/login" element={<LoginRedirect />} />
          <Route path="/register" element={<SignupScreen />} />
          <Route path="/forgotpassword" element={<ForgotPasswordScreen />} />
          <Route path="/dashboard" element={<BlogDashboardScreen />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
